// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfe_a bha_vc bha_rm bha_wf"};